<section class="preferences">
  <div class="interests">
    <ng-container *ngIf="getInterests$ | async as preferences">
      <h4>¿Cuáles son tus puntos de interés?</h4>

      <section class="interests-options">
        <ng-container *ngFor="let item of preferences?.response?.interests">
          <div class="chip-checkbox">
            <input
              type="checkbox"
              [id]="item.id"
              (click)="onChangeInterests(item)"
            />
            <label [for]="item.id" class="chip"> {{ item.name }} </label>
          </div>
        </ng-container>
      </section>

      <h4>¿Hay alguna información especial que necesites saber? (Opcional)</h4>
      <div class="ggi-textarea">
        <textarea
          rows="5"
          (keyup)="validateForm()"
          [(ngModel)]="interestExtraNotes"
          id="interestExtraNotes"
        ></textarea>
        <label for="interestExtraNotes">Escríbenos tu duda</label>
      </div>
      <p class="text-tiny error" *ngIf="interestExtraNotes.length > 300">
        Máximo 300 caracteres
      </p>

      <h4 class="question-title">{{ questionI?.question }}</h4>

      <div class="radios-content">
        <label
          class="ggi-radio"
          [ngClass]="{ open: answerOption.isOpen }"
          *ngFor="let answerOption of questionI?.answers"
        >
          <input
            type="radio"
            [(ngModel)]="answer"
            class="checkbox-question"
            value="{{ answerOption.text }}"
            id="{{ answerOption._id }}"
            (change)="validateForm()"
          />
          <span
            class="checkmark"
            [ngClass]="{ open: answerOption.isOpen }"
          ></span>
          <label
            class="body-2"
            for="{{ answerOption._id }}"
            *ngIf="!answerOption.isOpen"
          >
            {{ answerOption.text }}
          </label>
          <div class="ggi-input open-answer" *ngIf="answerOption.isOpen">
            <input
              type="input"
              (focus)="focusOpen()"
              placeholder="{{ answerOption.text }}"
              [(ngModel)]="openAnswer"
              (keyup)="validateForm()"
            />
          </div>
        </label>
      </div>
    </ng-container>
  </div>
</section>
